import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=3ed0125f&scoped=true"
import script from "./Success.vue?vue&type=script&lang=ts"
export * from "./Success.vue?vue&type=script&lang=ts"
import style0 from "./Success.vue?vue&type=style&index=0&id=3ed0125f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed0125f",
  null
  
)

export default component.exports